var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"version2-right-middle"},[_c('Header',{attrs:{"title":"专利奖"}}),_c('Bar',{attrs:{"options":_vm.options},on:{"echartClick":_vm.echartClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }